document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.getElementById("stickyTabs");
  const stickyOffset = tabs.offsetTop;

  window.addEventListener("scroll", function () {
    if (window.pageYOffset > stickyOffset) {
      tabs.classList.add("sticky-tabs");
    } else {
      tabs.classList.remove("sticky-tabs");
    }
  });
});